import { extractDeviceNameFromId } from "../utils/getEntityName";
import {
  errorNotification,
  successNotification,
} from "../variables/notification";

export const captureKeyframeForAllZones = async (
  deviceDetail: any,
  publishNode: (args: any) => Promise<any>
): Promise<void> => {
  const { extractedDeviceName } = extractDeviceNameFromId(deviceDetail?.rowId);

  try {
    const response = await publishNode({
      message: JSON.stringify({
        ACTION: "SAVE_ALL_ZONE_IMAGES",
        TARGET: "CAMERA_MANAGER",
        device_id: extractedDeviceName,
        ACK: deviceDetail?.node.id,
      }),
      nodeId: deviceDetail?.node.id ?? "",
    });

    if (response.data) {
      successNotification("New key images are being captured for all zones");
    }
  } catch (error) {
    errorNotification("Something went wrong, new key images aren't captured");

    console.error(error);
  }
};
